export const SOLUTION_COLORS = [
    { light: "#e2f3f8", dark: "#234461" },
    { light: "#f7e2e2", dark: "#a41a36" },
    { light: "#d1efed", dark: "#038478" },
    { light: "#f0e4f3", dark: "#570068" },
    { light: "#f9deeb", dark: "#b04174" }
];

// Only used for Family Portal
export const getSolutionClassIndex = (index: number): number => {
    return (index % 5) + 1; // operand 5 is the number of colors used in initials
};

export const getUserStatusClass = (status: number): string => {
    let statusClass = "status-away"; // default status
    switch (status) {
        case 1:
            statusClass = "status-available";
            break;
        case 2:
            statusClass = "status-busy";
            break;
        case 3:
            statusClass = "status-dnd";
            break;
        case 4:
            statusClass = "status-brb";
            break;
        case 5:
            statusClass = "status-away";
            break;
        case 6:
            statusClass = "status-offline";
            break;
        case 7:
            statusClass = "status-call";
            break;
    }
    return statusClass;
};
